import { setConversationsAction, deleteConversationAction } from './conversationsDuck';

/**
 * Conversation limit ("modo cola") — removes a conversation from the chat
 * list without going to the server.
 *
 * `closeIfOpen: true` (release) also closes the chat through the existing
 * `deleteConversationAction`. With `false` (unseated by the backend) the open
 * chat stays on screen so the agent can read the notice and finish typing.
 */
export const removeConversationLocallyAction =
  (clientId, { closeIfOpen = false } = {}) =>
  (dispatch, getState) => {
    if (closeIfOpen) {
      dispatch(deleteConversationAction({ client: { id: clientId } }));
      return;
    }
    const { data } = getState().conversations;
    if (!data.some((conversation) => conversation.id === clientId)) return;
    dispatch(setConversationsAction(data.filter((conversation) => conversation.id !== clientId)));
  };
